/**
 * @author PoornaChandu
 */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Highlighter from 'react-highlight-words';
import { connect } from 'react-redux';
import { message, Input, Button } from 'antd';
import { DeleteOutlined, FormOutlined, SearchOutlined } from '@ant-design/icons';
import constants from './../constants';
import StyledTable from '../../../commons/styles/table';
import { deleteRule, getRules } from './APICalls';
import { translation } from '../../../commons/translation';
import { useNavigate } from 'react-router-dom';

const AIList = (props) => {
  const [AIList, setAIList] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [searchText, setSearchText] = useState('');
    const navigate = useNavigate();
  
  useEffect(() => {
    const fetchAIList = async () => {
      try {
        let AIList = await getRules();
        setAIList(AIList);
      } catch (err) {
        message.warn('OOPS Something went Wrong');
      }
    };

    fetchAIList();
  }, []);

  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile]);

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const handleDelete = async (key) => {
    try {
      let data = await deleteRule(key);
      if (data.status === 200) {
        message.success('Deleted Rule');
        try {
          let AIList = await getRules();
          setAIList(AIList);
        } catch (err) {
          message.warn('OOPS Something went Wrong');
        }
      }
    } catch (err) {
      message.warn('Something went Wrong !');
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation(constants.search)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(constants.search)}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(constants.Reset)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const aiColumns = [
    {
      title: translation(constants.WhatToMonitor, props.translationCache),
      dataIndex: 'ProblemStatement',
      key: 'ProblemStatement',
      ...getColumnSearchProps('ProblemStatement')
    },
    {
      title: translation(constants.CurrentStep, props.translationCache),
      dataIndex: 'CurrentStep',
      key: 'CurrentStep',
      ...getColumnSearchProps('CurrentStep')
    },
    {
      title: translation('Status', props.translationCache),
      dataIndex: 'RuleStatus',
      key: 'RuleStatus',
      ...getColumnSearchProps('RuleStatus')
    },
    {
      title: translation(constants.createdTime, props.translationCache),
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
      ...getColumnSearchProps('CreatedDate'),
      render: (text) => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
    },
    {
      title: translation(constants.edit, props.translationCache),
      key: 'Edit',
      render: (text, record) => (
        <span>
          <FormOutlined
            style={{ color: '#1a3652' }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/rubus/AIRulesDetails?Id=${record.Id}`);
            }}
          />
        </span>
      )
    },
    {
      title: translation(constants.delete, props.translationCache),
      key: 'Delete',
      render: (text, record) => (
        <span>
          {record.RuleStatus !== 'Completed' ? (
            <DeleteOutlined
              style={{ color: 'red' }}
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(record);
              }}
            />
          ) : null}
        </span>
      )
    }
  ];

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          color: '#fff !important',
          marginTop: '10px'
        }}
      >
        <Button
          type="primary"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/rubus/AIRulesDetails`);
          }}
        >
          {translation('Create AI Rule', props.translationCache)}
        </Button>
        <Button
          type="primary"
          style={{ marginRight: '5px' }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/rubus/AI/fileupload`);
          }}
        >
          {translation('Redirect to Upload page', props.translationCache)}
        </Button>
      </div>
      <div style={{ marginTop: '25px' }}>
          <StyledTable size="small" columns={aiColumns} dataSource={AIList} />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.getUserProfile,
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(AIList);
